
export default {
  props: {
    slice: { type: Object, required: true },
  },
  computed: {
    primarySlice() {
      return this.slice.primary
    },
    ctas() {
      const contactUrl = `${process.env.nuroleAppBaseUrl}/contact`
      const requestUrl = `${process.env.nuroleAppBaseUrl}/request`

      switch (this.primarySlice.call_to_action) {
        case 'Custom':
          return [
            {
              label: this.primarySlice.custom_text,
              url: this.slice.primary.custom_link?.url,
            },
          ]
        case 'Boards / Candidates':
          return [
            { label: 'Boards & employers', url: '/employers' },
            { label: 'Candidates', url: '/candidates' },
          ]
        case 'Post a role / Request an invitation':
          return [
            { label: 'Get in touch', url: contactUrl },
            { label: 'Request an invitation', url: requestUrl },
          ]
        case 'co':
          return [{ label: 'Get in touch', url: contactUrl }]
        case 'Request an invitation':
          return [{ label: 'Request an invitation', url: requestUrl }]

        default:
          return []
      }
    },
  },
}
